import Indicator, { IndicatorType } from '../types/Indicator'

const AverageTrueRange: Indicator = {
  // ATR is a pip-distance magnitude, not a price level — comparing it to
  // price or moving averages is meaningless. OSCILLATOR limits its RHS
  // options to itself and a user Value (the volatility-filter use case) and
  // removes it from other indicators' RHS lists.
  type: IndicatorType.OSCILLATOR,
  value: 'atr',
  label: 'Average True Range',
  nickname: 'ATR',
  fields: ['atr'],
  params: {
    period: 14,
  },
}

export default AverageTrueRange
